import {useState, useEffect} from 'react';

import {useParams} from 'react-router';

import {getPublicABLocations} from 'api/accreditation-bodies';
import {alertByError} from 'utils/alerts';

const useGetLocations = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});

  const {abId} = useParams();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const {data, meta} = await getPublicABLocations(abId);
      setData(data);
      setMeta(meta);
    } catch (error) {
      alertByError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {isLoading, meta, data};
};

export default useGetLocations;
